<template>
  <div class="page-col page-main retorno-cadastro" :class="{'bg-dark': isDark}">
    <!-- Header Padrao -->
    <HeaderPadrao 
      class="mb-3" 
      icon="fa fa-file-text-o" 
      :titulo="tituloTela"
    >
      <template #subtitulo>
        <i class="fa fa-info-circle mr-1 text-info"></i>
        {{ subtitulo || 'Processamento de arquivo de retorno bancário' }}
      </template>

      <template #acoes>
        <b-button variant="link" class="btn-glass btn-glass-success mr-2" @click="processar" :disabled="!podeProcessar" v-if="isNovo">
          <i class="fa fa-check-circle mr-1"></i> PROCESSAR RETORNO
        </b-button>

        <b-button variant="light" pill class="font-weight-bold shadow-sm" @click="voltar">
          <i class="fa fa-arrow-left mr-1"></i> Voltar
        </b-button>
      </template>
    </HeaderPadrao>

    <div class="px-3">
      <!-- Seção Dados do Retorno -->
      <div class="card border-0 shadow-sm rounded-lg overflow-hidden mb-4" :class="isDark ? 'bg-dark border-secondary' : 'bg-white'">
        <div class="card-header bg-transparent border-0 p-4 pb-0">
          <div class="d-flex align-items-center">
            <div class="bg-primary text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 35px; height: 35px;">
              <i class="fa fa-info-circle"></i>
            </div>
            <h6 class="mb-0 font-weight-bold">Dados do Retorno</h6>
          </div>
        </div>
        <div class="card-body p-4">
          <b-row>
            <b-col md="6">
              <label class="modal-label-premium">Empresa</label>
              <b-form-select
                v-model="retorno.EMPRESA_ID"
                :options="empresas"
                :disabled="!isNovo"
                class="rounded-pill shadow-xs"
              >
                <template #first>
                  <option :value="null">Selecione a empresa</option>
                </template>
              </b-form-select>
            </b-col>

            <b-col md="6">
              <label class="modal-label-premium">Conta Bancária</label>
              <b-form-select
                v-model="retorno.CONTA_ID"
                :options="contas"
                :disabled="!isNovo"
                class="rounded-pill shadow-xs"
              >
                <template #first>
                  <option :value="null">Selecione a conta bancária</option>
                </template>
              </b-form-select>
            </b-col>
          </b-row>

          <b-row class="mt-3">
            <b-col md="3">
              <label class="modal-label-premium">Data Cadastro</label>
              <CecInputData
                v-model="retorno.DATA_CADASTRO"
                disabled
                input-class="rounded-pill shadow-xs bg-light"
              />
            </b-col>

            <b-col md="3">
              <label class="modal-label-premium">Data Arq. Retorno</label>
              <CecInputData
                v-model="retorno.DATA_ARQUIVO"
                :disabled="!isNovo"
                input-class="rounded-pill shadow-xs"
              />
            </b-col>

            <b-col md="3">
              <label class="modal-label-premium">Pasta Arq. Retorno</label>
              <b-form-input
                v-model="retorno.PATH_ARQUIVO_RETORNO"
                :disabled="!isNovo"
                class="rounded-pill shadow-xs"
              />
            </b-col>

            <b-col md="3">
              <label class="modal-label-premium">Nome Arq. Retorno</label>
              <b-form-input
                v-model="retorno.NOME_ARQUIVO_RETORNO"
                :disabled="!isNovo"
                class="rounded-pill shadow-xs"
              />
            </b-col>
          </b-row>

          <b-row v-if="isNovo" class="mt-3">
            <b-col md="12">
              <label class="modal-label-premium">Arquivo de Retorno</label>
              <b-input-group>
                <b-form-file
                  v-model="arquivoSelecionado"
                  accept=".txt,.TXT,.ret,.RET"
                  placeholder="Selecione o arquivo de retorno..."
                  browse-text="Procurar"
                  @change="onFileChange"
                  class="rounded-pill-left shadow-xs"
                ></b-form-file>
                <b-input-group-append>
                  <b-button variant="primary" @click="uploadArquivo" :disabled="!podeUpload || uploadingArquivo" class="rounded-pill-right shadow-sm">
                    <b-spinner small v-if="uploadingArquivo" class="mr-1"></b-spinner>
                    <i v-else class="fa fa-cloud-upload mr-1"></i>
                    {{ uploadingArquivo ? 'Enviando...' : 'Enviar' }}
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-col>
          </b-row>

          <b-row class="mt-4">
            <b-col md="3">
              <div class="p-3 rounded-lg bg-soft-primary border-0 shadow-xs h-100 text-center">
                <div class="modal-label-premium mb-1">Títulos Encontrados</div>
                <div class="h4 mb-0 font-weight-bold text-primary">{{ retorno.TITULOS_ENCONTRADOS || 0 }}</div>
              </div>
            </b-col>
            <b-col md="3">
              <div class="p-3 rounded-lg bg-soft-warning border-0 shadow-xs h-100 text-center">
                <div class="modal-label-premium mb-1">Títulos Não Encontrados</div>
                <div class="h4 mb-0 font-weight-bold text-warning">{{ retorno.TITULOS_NAO_ENCONTRADOS || 0 }}</div>
              </div>
            </b-col>
            <b-col md="3">
              <div class="p-3 rounded-lg bg-soft-success border-0 shadow-xs h-100 text-center">
                <div class="modal-label-premium mb-1">Valor Encontrado</div>
                <div class="h4 mb-0 font-weight-bold text-success">{{ formatCurrency(retorno.VALOR_ENCONTRADOS) }}</div>
              </div>
            </b-col>
            <b-col md="3">
              <div class="p-3 rounded-lg bg-soft-secondary border-0 shadow-xs h-100 text-center">
                <div class="modal-label-premium mb-1">Valor Não Encontrado</div>
                <div class="h4 mb-0 font-weight-bold text-secondary">{{ formatCurrency(retorno.VALOR_NAO_ENCONTRADOS) }}</div>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>

      <!-- Seção Boletos a Serem Processados -->
      <div class="card border-0 shadow-sm rounded-lg overflow-hidden mb-4" :class="isDark ? 'bg-dark border-secondary' : 'bg-white'">
        <div class="card-header bg-transparent border-0 p-4 pb-0">
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center">
              <div class="bg-success text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 35px; height: 35px;">
                <i class="fa fa-list"></i>
              </div>
              <h6 class="mb-0 font-weight-bold mr-3">Boletos a Serem Processados</h6>
              <div class="d-none d-md-flex align-items-center small text-muted">
                <i class="fa fa-circle text-warning mr-1"></i> Cancelado 
                <i class="fa fa-circle text-info ml-2 mr-1"></i> Registrado
                <i class="fa fa-circle text-indigo ml-2 mr-1"></i> Divergência
                <i class="fa fa-circle text-success ml-2 mr-1"></i> Liquidado
              </div>
            </div>
            <div>
              <b-button 
                size="sm" 
                variant="soft-primary" 
                pill
                class="mr-2 px-3"
                @click="mesmoHistoricoCompensacoes" 
                :disabled="itens.length === 0 || !itemSelecionado"
              >
                <i class="fa fa-sync mr-1"></i> Mesmo Histórico Compensações
              </b-button>
              <b-button 
                size="sm" 
                variant="soft-warning" 
                pill
                class="mr-2 px-3"
                @click="mesmoHistoricoDespesas" 
                :disabled="itens.length === 0 || !itemSelecionado"
              >
                <i class="fa fa-sync mr-1"></i> Mesmo Histórico Despesas
              </b-button>
              <b-button 
                size="sm" 
                variant="soft-success" 
                pill
                class="px-3"
                @click="exportarExcel" 
                :disabled="itens.length === 0"
              >
                <i class="fa fa-file-excel-o mr-1"></i> Excel
              </b-button>
            </div>
          </div>
        </div>

        <div class="card-body p-4">
          <div class="table-responsive rounded border shadow-sm overflow-hidden">
            <b-table
              :items="itens"
              :fields="colunasItens"
              :busy="loadingItens"
              class="modern-premium-table mb-0"
              hover
              small
              show-empty
              empty-text="Nenhum boleto para processar"
              selectable
              select-mode="single"
              @row-selected="onRowSelected"
              :tbody-tr-class="rowClassItem"
            >
              <template #cell(OP_SITUACAO_RETORNO)="data">
                <i 
                  class="fa fa-circle"
                  :class="'text-' + getSituacaoRetornoVariant(data.value)"
                ></i>
              </template>

              <template #cell(OP_BAIXA_TITULO)="data">
                <b-badge :variant="getBaixaTituloVariant(data.value)" pill class="px-2">
                  {{ getBaixaTituloText(data.value) }}
                </b-badge>
              </template>

              <template #cell(OP_LANCA_DESPESA)="data">
                <i 
                  class="fa fa-circle"
                  :class="data.value === 'S' ? 'text-danger' : 'text-secondary'"
                ></i>
              </template>

              <template #cell(OP_ANTECIPADO)="data">
                <i 
                  class="fa fa-exclamation-circle"
                  :class="data.value === 'S' ? 'text-info' : 'text-secondary'"
                ></i>
              </template>

              <template #cell(DATA_CREDITO)="data">
                <span class="text-muted">{{ formatDate(data.value) }}</span>
              </template>

              <template #cell(DATA_VENCIMENTO)="data">
                <span class="text-muted">{{ formatDate(data.value) }}</span>
              </template>

              <template #cell(VALOR_RECEBIDO)="data">
                <span class="font-weight-bold text-success">{{ formatCurrency(data.value) }}</span>
              </template>

              <template #cell(VALOR_DESPESA)="data">
                <span class="font-weight-bold text-danger">{{ formatCurrency(data.value) }}</span>
              </template>

              <template #cell(VALOR_ARECEBER_ORIGINAL)="data">
                <span class="font-weight-bold text-primary">{{ formatCurrency(data.value) }}</span>
              </template>

              <template #cell(HISTORICO_ID)="data">
                <div class="d-flex align-items-center">
                  <span class="mr-2 text-truncate" style="max-width: 150px;">{{ data.item.NOME_HISTORICO || '-' }}</span>
                  <b-button 
                    size="sm" 
                    variant="link" 
                    class="p-0 text-primary" 
                    @click="editarHistorico(data.item)"
                    v-if="isNovo && data.item.VALOR_RECEBIDO > 0"
                  >
                    <i class="fa fa-pencil"></i>
                  </b-button>
                </div>
              </template>

              <template #cell(HISTORICO_DESPESA_ID)="data">
                <div class="d-flex align-items-center">
                  <span class="mr-2 text-truncate" style="max-width: 150px;">{{ data.item.NOME_HISTORICO_DESPESA || '-' }}</span>
                  <b-button 
                    size="sm" 
                    variant="link" 
                    class="p-0 text-primary" 
                    @click="editarHistoricoDespesa(data.item)"
                    v-if="isNovo && data.item.VALOR_DESPESA > 0"
                  >
                    <i class="fa fa-pencil"></i>
                  </b-button>
                </div>
              </template>

              <template #table-busy>
                <div class="text-center text-primary my-4">
                  <b-spinner class="align-middle mr-2"></b-spinner>
                  <strong>Carregando boletos...</strong>
                </div>
              </template>

              <template #custom-foot>
                <b-tr class="bg-light font-weight-bold">
                  <b-td colspan="15" class="text-right">Total:</b-td>
                  <b-td class="text-right">{{ formatCurrency(totalValorAreceber) }}</b-td>
                  <b-td class="text-right">{{ formatCurrency(totalValorDespesa) }}</b-td>
                  <b-td class="text-right">{{ formatCurrency(totalValorRecebido) }}</b-td>
                </b-tr>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal para editar histórico -->
    <b-modal
      id="modal-editar-historico"
      title="Selecionar Histórico"
      @ok="salvarHistorico"
      ok-title="Confirmar"
      cancel-title="Cancelar"
    >
      <b-form-group label="Histórico" label-for="historico-select">
        <b-form-select
          id="historico-select"
          v-model="historicoSelecionadoId"
          :options="historicosCredito"
        >
          <template #first>
            <option :value="null">Selecione um histórico</option>
          </template>
        </b-form-select>
      </b-form-group>
    </b-modal>

    <!-- Modal para editar histórico de despesa -->
    <b-modal
      id="modal-editar-historico-despesa"
      title="Selecionar Histórico de Despesa"
      @ok="salvarHistoricoDespesa"
      ok-title="Confirmar"
      cancel-title="Cancelar"
    >
      <b-form-group label="Histórico de Despesa" label-for="historico-despesa-select">
        <b-form-select
          id="historico-despesa-select"
          v-model="historicoDespesaSelecionadoId"
          :options="historicosDebito"
        >
          <template #first>
            <option :value="null">Selecione um histórico</option>
          </template>
        </b-form-select>
      </b-form-group>
    </b-modal>

  </div>
</template>

<script>
import Tools from '@/tools/tools.js'
import moment from 'moment'
import HeaderPadrao from '@/components/Cec/HeaderPadrao.vue'
import CecInputData from '@/components/Cec/CecInputData.vue'
import { exportExcelXlsx } from '@/utils/RelatorioHTML'

export default {
  name: 'BoletoRetornoCadastro',
  components: { HeaderPadrao, CecInputData },
  props: {
    id: { type: [String, Number], default: null }
  },
  data() {
    return {
      retorno: {
        ID: null,
        DATA_CADASTRO: moment().format('YYYY-MM-DD'),
        DATA_ARQUIVO: null,
        PATH_ARQUIVO_RETORNO: '',
        NOME_ARQUIVO_RETORNO: '',
        CONTA_ID: null,
        BANCO_ID: null,
        EMPRESA_ID: null,
        TITULOS_ENCONTRADOS: 0,
        TITULOS_NAO_ENCONTRADOS: 0,
        VALOR_ENCONTRADOS: 0,
        VALOR_NAO_ENCONTRADOS: 0,
        STATUS: '1'
      },
      itens: [],
      loadingItens: false,
      uploadingArquivo: false,
      empresas: [],
      contas: [],
      arquivoSelecionado: null,
      arquivoConteudo: null,
      itemSelecionado: null,
      itemEditando: null,
      historicoSelecionadoId: null,
      historicoDespesaSelecionadoId: null,
      historicosCredito: [],
      historicosDebito: [],
      colunasItens: [
        
        { key: 'OP_SITUACAO_RETORNO', label: 'R', sortable: true, class: 'align-middle text-center', thStyle: { width: '2%' } },
        { key: 'NOSSO_NUMERO', label: 'Nosso Número', sortable: true, class: 'align-middle', thStyle: { width: '6%' } },
        { key: 'DOCUMENTO_ARECEBER', label: 'Título', sortable: true, class: 'align-middle', thStyle: { width: '5%' } },
        { key: 'PARCELA_ARECEBER', label: 'Parc', sortable: true, class: 'align-middle text-center', thStyle: { width: '3%' } },
        { key: 'NOME_CLIENTE', label: 'Cliente do Sistema', sortable: true, class: 'align-middle', thStyle: { width: '13%' } },
        { key: 'NOME_SACADO', label: 'Sacado', sortable: true, class: 'align-middle', thStyle: { width: '9%' } },
        { key: 'MOTIVO_REJEICAO', label: 'Mensagem/Rejeição', sortable: true, class: 'align-middle', thStyle: { width: '8%' } },
        { key: 'MOTIVO_RETORNO', label: 'Retorno', sortable: true, class: 'align-middle', thStyle: { width: '7%' } },
        { key: 'DATA_CREDITO', label: 'Crédito/Proces', sortable: true, class: 'align-middle text-center', thStyle: { width: '5%' } },
        { key: 'DATA_VENCIMENTO', label: 'Vencimento', sortable: true, class: 'align-middle text-center', thStyle: { width: '5%' } },
        { key: 'OP_BAIXA_TITULO', label: 'Baixa', sortable: false, class: 'align-middle text-center', thStyle: { width: '3%' } },
        { key: 'OP_LANCA_DESPESA', label: 'Despesa', sortable: false, class: 'align-middle text-center', thStyle: { width: '3%' } },
        { key: 'OP_ANTECIPADO', label: 'Antecipado', sortable: false, class: 'align-middle text-center', thStyle: { width: '3%' } },
        { key: 'HISTORICO_ID', label: 'Histórico Recebimento', sortable: false, class: 'align-middle', thStyle: { width: '10%' } },
        { key: 'HISTORICO_DESPESA_ID', label: 'Histórico Despesa', sortable: false, class: 'align-middle', thStyle: { width: '9%' } },
        { key: 'VALOR_ARECEBER_ORIGINAL', label: 'Valor Areceber', sortable: true, class: 'align-middle text-right', thStyle: { width: '6%' } },
        { key: 'VALOR_DESPESA', label: 'Despesa', sortable: false, class: 'align-middle text-right', thStyle: { width: '4%' } },
        { key: 'VALOR_RECEBIDO', label: 'Valor Recebido', sortable: true, class: 'align-middle text-right', thStyle: { width: '6%' } }
      ]
    }
  },
  computed: {
    isDark() { return this.$store.getters['tema/IS_DARK'] },
    
    isNovo() {
      return !this.retorno.ID || this.retorno.ID === 'novo'
    },
    
    tituloTela() {
      return this.isNovo ? 'Processamento de Arquivo de Retorno' : 'Consultando Retorno de Boletos'
    },
    
    subtitulo() {
      const parts = []
      if (this.retorno.ID && this.retorno.ID !== 'novo') {
        parts.push(`#${this.retorno.ID}`)
      }
      if (this.retorno.NOME_ARQUIVO_RETORNO) {
        parts.push(this.retorno.NOME_ARQUIVO_RETORNO)
      }
      return parts.length > 0 ? parts.join(' - ') : ''
    },
    
    podeUpload() {
      return this.isNovo && this.arquivoSelecionado && this.retorno.EMPRESA_ID && this.retorno.CONTA_ID
    },
    
    podeProcessar() {
      return this.isNovo && this.itens.length > 0
    },
    
    totalValorRecebido() {
      return this.itens.reduce((sum, item) => sum + (Number(item.VALOR_RECEBIDO) || 0), 0)
    },
    
    totalValorDespesa() {
      return this.itens.reduce((sum, item) => sum + (Number(item.VALOR_DESPESA) || 0), 0)
    },
    
    totalValorAreceber() {
      return this.itens.reduce((sum, item) => sum + (Number(item.VALOR_ARECEBER_ORIGINAL) || 0), 0)
    }
  },
  created() {
    this.carregarEmpresas()
    this.carregarContas()
    this.carregarHistoricos()
    
    const routeId = this.id || (this.$route && this.$route.params && this.$route.params.id)
    if (routeId && routeId !== 'novo') {
      this.carregarRetorno(routeId)
    }
  },
  methods: {
    async carregarEmpresas() {
      try {
        const { data } = await this.$http.get('/api/protected/empresa/getTodas')
        this.empresas = (data || []).map(emp => ({
          value: emp.CODIGO,
          text: `${emp.APELIDO} - ${emp.IE} - ${emp.RAZAO}`
        }))
      } catch (err) {
        console.error('Erro ao carregar empresas:', err)
      }
    },
    
    async carregarContas() {
      try {
        const body = {
          login: window.localStorage.getItem('login'),
          origem: 'web'
        }
        
        const { data } = await this.$http.post('/api/protected/conta/listarPorLogin', body)
        this.contas = (data || []).map(conta => ({
          value: conta.CODIGO,
          text: conta.NOME_CONTA
        }))
      } catch (err) {
        console.error('Erro ao carregar contas:', err)
        this.$bvToast.toast('Erro ao carregar contas bancárias', { variant: 'danger', solid: true })
      }
    },
    
    async carregarHistoricos() {
      try {
        // Carregar históricos de crédito
        const { data: creditos } = await this.$http.post('/api/protected/historico/pesquisar', { TIPO: 'CREDITO' })
        this.historicosCredito = (creditos || []).map(h => ({
          value: h.CODIGO,
          text: h.DESCRICAO
        }))
        
        // Carregar históricos de débito
        const { data: debitos } = await this.$http.post('/api/protected/historico/pesquisar', { TIPO: 'DEBITO' })
        this.historicosDebito = (debitos || []).map(h => ({
          value: h.CODIGO,
          text: h.DESCRICAO
        }))
      } catch (err) {
        console.error('Erro ao carregar históricos:', err)
      }
    },
    
    async carregarRetorno(id) {
      try {
        this.$store.commit('controle/setAguardando', true)
        
        const { data } = await this.$http.get(`/api/protected/boleto/retorno/getById/${id}`)
        const registro = Array.isArray(data) ? data[0] : data
        
        if (!registro) {
          throw new Error('Retorno não encontrado')
        }
        
        Object.assign(this.retorno, {
          ID: registro.ID,
          DATA_CADASTRO: registro.DATA_CADASTRO ? moment(registro.DATA_CADASTRO).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
          DATA_ARQUIVO: registro.DATA_ARQUIVO ? moment(registro.DATA_ARQUIVO).format('YYYY-MM-DD') : null,
          PATH_ARQUIVO_RETORNO: registro.PATH_ARQUIVO_RETORNO || '',
          NOME_ARQUIVO_RETORNO: registro.NOME_ARQUIVO_RETORNO || '',
          CONTA_ID: registro.CONTA_ID,
          BANCO_ID: registro.BANCO_ID,
          EMPRESA_ID: registro.EMPRESA_ID,
          TITULOS_ENCONTRADOS: registro.TITULOS_ENCONTRADOS || 0,
          TITULOS_NAO_ENCONTRADOS: registro.TITULOS_NAO_ENCONTRADOS || 0,
          VALOR_ENCONTRADOS: registro.VALOR_ENCONTRADOS || 0,
          VALOR_NAO_ENCONTRADOS: registro.VALOR_NAO_ENCONTRADOS || 0,
          STATUS: registro.STATUS || '1'
        })
        
        // Carregar itens do retorno
        await this.carregarItens()
        
        // Setar o ID no store para manter destaque na listagem
        if (this.retorno.ID) {
          this.$store.commit('boletoRetorno/SET_REGISTRO_SELECIONADO_ID', this.retorno.ID)
        }
        
      } catch (err) {
        console.error('Erro ao carregar retorno:', err)
        const mensagem = err?.response?.data?.erro || err?.message || 'Erro ao carregar retorno'
        this.$bvToast.toast(mensagem, { variant: 'danger', solid: true })
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    
    async carregarItens() {
      if (!this.retorno.ID || this.retorno.ID === 'novo') return
      
      try {
        this.loadingItens = true
        
        const { data } = await this.$http.get(`/api/protected/boleto/retorno/getItens/${this.retorno.ID}`)
        this.itens = Array.isArray(data) ? data : []
        
        // Mapear os nomes dos históricos a partir dos IDs
        this.itens.forEach(item => {
          if (item.HISTORICO_ID) {
            const historico = this.historicosCredito.find(h => h.value === item.HISTORICO_ID)
            if (historico) {
              item.NOME_HISTORICO = historico.text
            }
          }
          
          if (item.HISTORICO_DESPESA_ID) {
            const historicoDespesa = this.historicosDebito.find(h => h.value === item.HISTORICO_DESPESA_ID)
            if (historicoDespesa) {
              item.NOME_HISTORICO_DESPESA = historicoDespesa.text
            }
          }
        })
        
      } catch (err) {
        console.error('Erro ao carregar itens:', err)
        const mensagem = err?.response?.data?.erro || err?.message || 'Erro ao carregar itens'
        this.$bvToast.toast(mensagem, { variant: 'danger', solid: true })
        this.itens = []
      } finally {
        this.loadingItens = false
      }
    },
    
    onFileChange(event) {
      const file = event.target.files[0]
      if (file) {
        this.arquivoSelecionado = file
        const reader = new FileReader()
        reader.onload = (e) => {
          this.arquivoConteudo = e.target.result
        }
        reader.readAsText(file)
      }
    },
    
    async uploadArquivo() {
      if (!this.validar()) return
      
      if (!this.arquivoSelecionado) {
        this.$bvToast.toast('Selecione um arquivo', { variant: 'warning', solid: true })
        return
      }
      
      try {
        this.$store.commit('controle/setAguardando', true)
        this.uploadingArquivo = true
        
        // Converter arquivo para base64
        const arquivoBase64 = btoa(unescape(encodeURIComponent(this.arquivoConteudo)))
        
        const payload = {
          usuario: window.localStorage.getItem('login'),
          empresaId: this.retorno.EMPRESA_ID,
          contaId: this.retorno.CONTA_ID,
          nomeArquivo: this.arquivoSelecionado.name,
          arquivoRetornoBase64: arquivoBase64
        }
        
        const { data } = await this.$http.post('/api/protected/integrador/processarRetornoBoleto/', payload)
        
        
        if (data && data.sucesso) {
          // Atualizar dados do retorno - o backend retorna em data.retorno
          const resumo = data.retorno || {}
          this.retorno.TITULOS_ENCONTRADOS = resumo.titulosEncontrados || resumo.TITULOS_ENCONTRADOS || 0
          this.retorno.TITULOS_NAO_ENCONTRADOS = resumo.titulosNaoEncontrados || resumo.TITULOS_NAO_ENCONTRADOS || 0
          this.retorno.VALOR_ENCONTRADOS = resumo.vlEncontrados || resumo.valorEncontrados || resumo.VALOR_ENCONTRADOS || 0
          this.retorno.VALOR_NAO_ENCONTRADOS = resumo.vlNaoEncontrados || resumo.valorNaoEncontrados || resumo.VALOR_NAO_ENCONTRADOS || 0
          
          // Atualizar path e nome do arquivo
          this.retorno.PATH_ARQUIVO_RETORNO = this.arquivoSelecionado.webkitRelativePath || this.arquivoSelecionado.name
          this.retorno.NOME_ARQUIVO_RETORNO = this.arquivoSelecionado.name
          
          // Carregar itens - backend pode retornar objeto único ou array
          if (Array.isArray(data.itens)) {
            this.itens = data.itens
          } else if (data.itens && typeof data.itens === 'object') {
            // Se for um objeto único, converte em array
            this.itens = [data.itens]
          } else {
            this.itens = []
          }
          
          // Mapear os nomes dos históricos a partir dos IDs
          this.itens.forEach(item => {
            if (item.HISTORICO_ID) {
              const historico = this.historicosCredito.find(h => h.value === item.HISTORICO_ID)
              if (historico) {
                item.NOME_HISTORICO = historico.text
              }
            }
            
            if (item.HISTORICO_DESPESA_ID) {
              const historicoDespesa = this.historicosDebito.find(h => h.value === item.HISTORICO_DESPESA_ID)
              if (historicoDespesa) {
                item.NOME_HISTORICO_DESPESA = historicoDespesa.text
              }
            }
          })
          
          
          this.$bvToast.toast('Arquivo processado com sucesso!', { variant: 'success', solid: true })
        } else {
          throw new Error(data?.erro || 'Erro ao processar arquivo')
        }
        
      } catch (err) {
        console.error('Erro ao fazer upload:', err)
        const mensagem = err?.response?.data?.erro || err?.message || 'Erro ao fazer upload do arquivo'
        this.$bvToast.toast(mensagem, { variant: 'danger', solid: true })
      } finally {
        this.$store.commit('controle/setAguardando', false)
        this.uploadingArquivo = false
      }
    },
    
    async processar() {
      if (!this.validar()) return
      
      if (this.itens.length === 0) {
        this.$bvToast.toast('Não há itens para processar', { variant: 'warning', solid: true })
        return
      }
      
      const confirmado = await this.$bvModal.msgBoxConfirm(
        `Confirma o processamento do arquivo de retorno com ${this.itens.length} itens?`,
        {
          title: 'Confirmar Processamento',
          okVariant: 'success',
          okTitle: 'Sim, Processar',
          cancelTitle: 'Não'
        }
      )
      
      if (!confirmado) return
      
      try {
        this.$store.commit('controle/setAguardando', true)
        
        const payload = {
          registro: {...this.retorno},
          itens: this.itens,
          usuario: window.localStorage.getItem('login')
        }
        
        const { data } = await this.$http.post('/api/protected/boleto/retorno/processar', payload)
        
        if (data && data.sucesso) {
          this.$bvToast.toast('Retorno processado com sucesso!', { variant: 'success', solid: true })
          
          // Setar o ID do retorno criado para manter seleção na listagem
          if (data.retornoId) {
            this.$store.commit('boletoRetorno/SET_REGISTRO_SELECIONADO_ID', data.retornoId)
          }
          
          // Sinalizar para recarregar a lista ao voltar
          this.$store.commit('boletoRetorno/SET_DEVE_RECARREGAR_LISTA', true)
          
          setTimeout(() => {
            this.$router.push('/faturamento/retorno/index')
          }, 100)
        } else {
          throw new Error(data?.erro || 'Erro ao processar retorno')
        }
        
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    
    onRowSelected(items) {
      this.itemSelecionado = items && items.length > 0 ? items[0] : null
    },
    
    rowClassItem(item) {
      return item === this.itemSelecionado ? 'table-primary' : ''
    },
    
    mesmoHistoricoCompensacoes() {
      if (!this.itemSelecionado || !this.itemSelecionado.HISTORICO_ID) {
        this.$bvToast.toast('Selecione um item com histórico definido', { variant: 'warning', solid: true })
        return
      }
      
      const historicoId = this.itemSelecionado.HISTORICO_ID
      const nomeHistorico = this.itemSelecionado.NOME_HISTORICO
      
      this.itens.forEach(item => {
        if (item.VALOR_RECEBIDO > 0) {
          item.HISTORICO_ID = historicoId
          item.NOME_HISTORICO = nomeHistorico
          
          // Atualizar OP_BAIXA_TITULO se houver histórico e situação diferente de '0'
          if (historicoId && item.OP_SITUACAO_RETORNO !== '0') {
            item.OP_BAIXA_TITULO = 'S'
          }
        }
      })
      
      this.$bvToast.toast('Histórico aplicado para compensações', { variant: 'success', solid: true })
    },
    
    mesmoHistoricoDespesas() {
      if (!this.itemSelecionado || !this.itemSelecionado.HISTORICO_DESPESA_ID) {
        this.$bvToast.toast('Selecione um item com histórico de despesa definido', { variant: 'warning', solid: true })
        return
      }
      
      const historicoDespesaId = this.itemSelecionado.HISTORICO_DESPESA_ID
      const nomeHistoricoDespesa = this.itemSelecionado.NOME_HISTORICO_DESPESA
      
      this.itens.forEach(item => {
        if (item.VALOR_DESPESA > 0) {
          item.HISTORICO_DESPESA_ID = historicoDespesaId
          item.NOME_HISTORICO_DESPESA = nomeHistoricoDespesa
          
          // Atualizar OP_LANCA_DESPESA se houver histórico de despesa
          if (historicoDespesaId) {
            item.OP_LANCA_DESPESA = 'S'
          }
        }
      })
      
      this.$bvToast.toast('Histórico aplicado para despesas', { variant: 'success', solid: true })
    },
    
    editarHistorico(item) {
      if (item.VALOR_RECEBIDO <= 0) {
        this.$bvToast.toast('Só é permitido editar histórico de recebimento quando o valor recebido for maior que zero', { variant: 'warning', solid: true })
        return
      }
      this.itemEditando = item
      this.historicoSelecionadoId = item.HISTORICO_ID
      this.$bvModal.show('modal-editar-historico')
    },
    
    salvarHistorico() {
      if (this.itemEditando && this.historicoSelecionadoId) {
        const historico = this.historicosCredito.find(h => h.value === this.historicoSelecionadoId)
        this.itemEditando.HISTORICO_ID = this.historicoSelecionadoId
        this.itemEditando.NOME_HISTORICO = historico ? historico.text : ''
        
        // Atualizar OP_BAIXA_TITULO se houver histórico e situação diferente de '0' (Cancelado)
        if (this.historicoSelecionadoId && this.itemEditando.OP_SITUACAO_RETORNO !== '0') {
          this.itemEditando.OP_BAIXA_TITULO = 'S'
        }
        
        this.$forceUpdate()
      }
    },
    
    editarHistoricoDespesa(item) {
      if (item.VALOR_DESPESA <= 0) {
        this.$bvToast.toast('Só é permitido editar histórico de despesa quando o valor da despesa for maior que zero', { variant: 'warning', solid: true })
        return
      }
      this.itemEditando = item
      this.historicoDespesaSelecionadoId = item.HISTORICO_DESPESA_ID
      this.$bvModal.show('modal-editar-historico-despesa')
    },
    
    salvarHistoricoDespesa() {
      if (this.itemEditando && this.historicoDespesaSelecionadoId) {
        const historico = this.historicosDebito.find(h => h.value === this.historicoDespesaSelecionadoId)
        this.itemEditando.HISTORICO_DESPESA_ID = this.historicoDespesaSelecionadoId
        this.itemEditando.NOME_HISTORICO_DESPESA = historico ? historico.text : ''
        
        // Atualizar OP_LANCA_DESPESA se houver histórico de despesa
        if (this.historicoDespesaSelecionadoId) {
          this.itemEditando.OP_LANCA_DESPESA = 'S'
        }
        
        this.$forceUpdate()
      }
    },
    
    getBaixaTituloVariant(valor) {
      if (valor === 'N') return 'secondary'
      if (valor === 'S') return 'success'
      if (valor === 'X') return 'warning'
      return 'secondary'
    },
    
    getBaixaTituloText(valor) {
      if (valor === 'N') return 'Não baixar'
      if (valor === 'S') return 'Baixar'
      if (valor === 'X') return 'Alerta'
      return '-'
    },
    
    getSituacaoRetornoIcon(valor) {
      // R = Registro de cobrança, L = Liquidado, etc
      return 'circle-fill'
    },
    
    getSituacaoRetornoVariant(valor) {
      const situacao = String(valor || '').trim()
      if (situacao === '0') return 'warning'
      if (situacao === '1') return 'info'
      if (situacao === '2') return 'indigo'
      if (situacao === '3') return 'success'
      return 'secondary'
    },
    
    exportarExcel() {
      exportExcelXlsx({
        rows: this.itens,
        columns: this.colunasItens,
        filename: `retorno-boletos-itens-${this.retorno.ID || 'novo'}.xls`
      })
    },
    
    validar() {
      if (!this.retorno.EMPRESA_ID) {
        this.$bvToast.toast('Selecione a empresa', { variant: 'warning', solid: true })
        return false
      }
      
      if (!this.retorno.CONTA_ID) {
        this.$bvToast.toast('Selecione a conta bancária', { variant: 'warning', solid: true })
        return false
      }
      
      return true
    },
    
    voltar() {
      this.$router.push('/faturamento/retorno/index')
    },
    
    formatDate(val) {
      return val ? moment(String(val)).format('DD/MM/YYYY') : ''
    },
    
    formatCurrency(val) {
      return val != null ? val.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : 'R$ 0,00'
    }
  }
}
</script>

<style lang="scss">
.retorno-cadastro {
  .cec-header__icon {
    background: rgba(255, 255, 255, 0.15) !important;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15) !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    
    &::before {
      display: block !important;
    }
  }
}

.modal-label-premium {
  font-size: 0.7rem;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 0.4rem;
  display: block;
}

.btn-glass {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(4px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white !important;
  border-radius: 20px;
  padding: 6px 16px;
  font-weight: 600;
  font-size: 0.8rem;
  transition: all 0.2s;
  
  &:hover {
    background: rgba(255, 255, 255, 0.2);
    transform: translateY(-1px);
    text-decoration: none;
  }
  
  &.btn-glass-success {
    background: rgba(40, 167, 69, 0.2);
    border-color: rgba(40, 167, 69, 0.3);
    &:hover { background: rgba(40, 167, 69, 0.3); }
  }
}

.rounded-pill-20 {
  border-radius: 20px !important;
}

.modern-premium-table {
  border-collapse: separate;
  border-spacing: 0;
  
  thead th {
    background-color: #f8fafc !important;
    color: #64748b !important;
    font-weight: 600 !important;
    text-transform: uppercase !important;
    font-size: 0.75rem !important;
    letter-spacing: 0.025em !important;
    padding: 12px 16px !important;
    border-top: none !important;
    border-bottom: 2px solid #e2e8f0 !important;
  }
  
  tbody td {
    padding: 8px 16px !important;
    vertical-align: middle !important;
    border-bottom: 1px solid #edf2f7 !important;
    font-size: 0.875rem !important;
  }
  
  tbody tr {
    transition: all 0.2s;
    
    &:hover {
      background-color: #f1f5f9 !important;
    }
    
    &.cec-row-selected {
      background-color: #e0f2fe !important;
      td {
        color: #0369a1 !important;
        font-weight: 500;
      }
    }
  }
}

.bg-soft-success { background-color: rgba(34, 197, 94, 0.1); }
.bg-soft-info { background-color: rgba(14, 165, 233, 0.1); }
.bg-soft-primary { background-color: rgba(59, 130, 246, 0.1); }
.bg-soft-warning { background-color: rgba(245, 158, 11, 0.1); }
.bg-soft-secondary { background-color: rgba(100, 116, 139, 0.1); }

.shadow-xs { box-shadow: 0 1px 2px rgba(0,0,0,0.05); }

.custom-checkbox-premium {
  .custom-control-label::before {
    border-radius: 4px;
    border: 2px solid #cbd5e1;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/faturamento/boleto/BoletoRetornoCadastro.vue